import React, { memo, useCallback } from 'react'

import { TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string, bool } from 'prop-types'

import ToggleSelector from 'Pods/ThreeDStudio/Shared/ToggleSelector/ToggleSelector'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

function ToggleWithInputSelector({
  id,
  keyName,
  sliceName,
  setFunction,
  label,
  inputKeyName,
  setInputFunction,
  disabled = false,
}) {
  const inputValue = useThreeDStudioStore(
    state => state.modelSettings?.[inputKeyName]
  )

  const handleInputChange = useCallback(
    (e) => {
      const value = e.target.value
      if (value === '') {
        setInputFunction(value)

        return
      }

      const numValue = parseInt(value, 10)
      if (!Number.isNaN(numValue) && numValue >= 0) {
        setInputFunction(numValue)
      }
    },
    [setInputFunction]
  )

  const handleInputBlur = useCallback(() => {
    if (inputValue === '') {
      setFunction(false)
    }
  }, [inputValue, setFunction])

  return (
    <div className="model-settings__row">
      <ToggleSelector
        id={`${id}-toggle`}
        keyName={keyName}
        sliceName={sliceName}
        label={label}
        setFunction={setFunction}
        disabled={disabled}
      />
      <TextInput
        value={inputValue || ''}
        onChange={handleInputChange}
        size="small"
        id={`${id}-input`}
        isPilot
        textInputClassName="model-settings__input"
        onBlur={handleInputBlur}
        isDisabled={disabled}
      />
    </div>
  )
}

ToggleWithInputSelector.propTypes = {
  id: string.isRequired,
  keyName: string.isRequired,
  sliceName: string.isRequired,
  setFunction: func.isRequired,
  label: string.isRequired,
  inputKeyName: string.isRequired,
  setInputFunction: func.isRequired,
  disabled: bool,
}

export default memo(ToggleWithInputSelector)
